import { makeUrlImage } from '../hooks/connectionData'

export const makeImage = (id: string) => makeUrlImage(id)
export const makeSmallImage = (id: string) => {
  const url = new URL(makeImage(id))

  url.searchParams.append('type', 'thumbnail')
  url.searchParams.append('size', 'sm')

  return url.href
}
